import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DigitalAsset, GungModalService } from 'gung-standard';
import { TyloDigitalAssetsModalComponent } from '../components/digital-assets/tylo-digital-assets-modal/tylo-digital-assets-modal.component';

@Injectable({
  providedIn: 'root'
})
export class TyloModalService extends GungModalService{

  openDigitalAssetsModal(digitalAsset: DigitalAsset, modalOptions?: NgbModalOptions) {
    const id = TyloDigitalAssetsModalComponent.name;
    const option: NgbModalOptions = {
      backdrop: true,
      size: 'xl',
      keyboard: true,
      centered: true,
      scrollable: true,
      ...modalOptions
    };
    const ref = this.ngbModal.open(TyloDigitalAssetsModalComponent, option);
    ref.componentInstance.delegate = this;
    ref.componentInstance.selectedDigitalAsset = digitalAsset;

    this.modalRef.set(id, ref);
    return ref.result;
  }
}
